// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Home.css */
.content {
    padding: 2rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/Profile.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,aAAa;EACf","sourcesContent":["/* src/pages/Home.css */\n.content {\n    padding: 2rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
